export interface CartItem {
  vehicleId: string;
  brand: string;
  model: string;
  pricePerDay: number;
  image: string;
  pickupDate: string;
  returnDate: string;
  days: number;
  pickupLocation: string;
  returnLocation: string;
}

export const locations = [
  'Cancún Aeropuerto',
  'Cancún Zona Hotelera',
  'Playa del Carmen',
  'Tulum',
  'Tulum Aeropuerto',
  'Miami Aeropuerto',
  'Miami Beach',
  'Key West',
  'Oficina Principal'
];